export function parseJwt(token) {
      if (!token) return null;
      try {
        const base64Url = token.split('.')[1];
        if (!base64Url) return null;
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map(c => `%${('00' + c.charCodeAt(0).toString(16))?.slice(-2)}`)
            .join('')
        );
        return JSON.parse(jsonPayload);
      } catch (e) {
        console.error('Error al decodificar JWT:', e);
        return null;
      }
}

export function setLogoutTimer(token, logoutCallback) {
  const payload = parseJwt(token);
  if (!payload || !payload.exp) return;

  const currentTime = Date.now() / 1000;
  const expiresIn = payload.exp - currentTime;

  if (expiresIn <= 0) {
    logoutCallback();
    return;
  }

  // Configurar cierre de sesión automático
  setTimeout(() => {
    logoutCallback();
  }, expiresIn * 1000); // convierte segundos a milisegundos
}
